import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;

/* eslint-disable import/prefer-default-export */

export var medianPriceCard = /*#__PURE__*/css("display:block;border:1px solid ", colors.neutral.trim.default, ";text-decoration:none;border-radius:3px;background:", colors.neutral.surface.default, ";color:", colors.neutral.heavy.default, ";min-width:243px;height:220px;padding-bottom:20px;padding-left:16px;");
export var localityLinkCard = {
  name: "1huthg8",
  styles: "padding-left:0;padding-right:0;"
};